import { render, staticRenderFns } from "./TimeRealReserve.vue?vue&type=template&id=535abf64"
import script from "./TimeRealReserve.vue?vue&type=script&lang=js"
export * from "./TimeRealReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports